import {createSelector} from 'reselect'

export const getSearchDialogIsOpen = (state) => state.search.open
export const getSearchQuery = (state) => state.search;
export const getSearchResults = (state) => state.search.results;
export const getSearchLoading = (state) => state.search.loading;
export const hasMoreSearchPages = (state) => state.search.page < state.search.total_pages;
export const getTotalSearchResults = (state) => state.search.total_results;

export const getIsSearchEmpty = createSelector(
    getSearchQuery,
    (query) => {
        return !query || (!query.query && !query.tags.length && !query.categories.length && !query.gender.length)
    }
)


// WEBPACK FOOTER //
// ./src/selectors/search.js